import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { Taxes } from "@/components/Taxes";
import { useParams } from "@/lib/navigation";

function TaxDetailContent() {
  const params = useParams();
  const entityId = params?.entity_id as string;
  const taxYear = params?.tax_year as string;

  return <Taxes entityId={entityId} taxYear={taxYear} />;
}

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <TaxDetailContent />
    </Suspense>
  );
}

export const Route = createFileRoute("/_authenticated/taxes/$entity_id/$tax_year/")({
  component: RouteComponent,
  staticData: { page: ["tax", "deals"] },
});
